import styles from "./FleekTab.module.css"
import FleekTabImg from "../../asset/icons/FleekTabImage.png"
import ScannerImg from "../../asset/icons/scanner.png"
import AppStore from "../../asset/icons/appStore.png"
import GooglePlay from "../../asset/icons/googlePlay.png"
import { NavBar } from "../../commonComponents";
import { storeLinkProps, STORES, PLACEMENTS } from "../../utils/storeLinks";


export const FleekTab = ()=>{
    return (
        <>
            {/* <NavBar/> */}
            <div className={styles.content}>
                <img src={FleekTabImg} alt="FleekTabImg" className={styles.fleekImg}/>
                <p className={styles.text1}>Manage</p>
                <p className={styles.text2}>
                    Auto-pay, Share and Cancel your<br/>
                    subscriptions only on Fleek!
                </p>
                <a className={styles.customButton} {...storeLinkProps(STORES.PLAY, PLACEMENTS.FLEEK_TAB_HERO)} rel="noreferrer" target="_blank">
                    DOWNLOAD NOW
                </a>
                <div className={styles.DesktopTab}>
                    <img src={ScannerImg} alt="ScannerImg" className={styles.scannerImg}/>
                    <div className={styles.side}>
                        <p className={styles.head}>
                            Install the app to Manage<br/> your subscriptions
                        </p>
                        <p className={styles.head1}>
                            Scan to Install
                        </p>
                        <div className={styles.buttonContainer}>
                            <a className={styles.buttonAnchor} {...storeLinkProps(STORES.APP_STORE, PLACEMENTS.FLEEK_TAB_CTA)} rel="noreferrer" target="_blank">
                                <img className={styles.buttonImg} src={AppStore} alt="AppStore" />
                            </a>
                            <a className={styles.buttonAnchor} {...storeLinkProps(STORES.PLAY, PLACEMENTS.FLEEK_TAB_CTA)} rel="noreferrer" target="_blank">
                                <img className={styles.buttonImg} src={GooglePlay} alt="GooglePlay" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            {/* <MobileBottomNavBar type={"fleekTab"}/> */}
        </>
        
    )
}